// gatsby-browser.js
import React from "react"
import { DataProvider } from "./src/context/DataContext"
import "./src/styles/main.css"

// wrapRootElement is valid in both gatsby-browser and gatsby-ssr:
export const wrapRootElement = ({ element }) => (
  <DataProvider>{element}</DataProvider>
)
